import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////

const BG = {
	blockTitle: '',
	blockDesc: '',
	blockContent: {
		left: {
			gap: 'gap24', // classname from css file (block.scss) for space between items
			content: [
				{
					title: 'Онлайн магазин. Готов <span class="nowrap">за старт.</span>',
					text: 'Shopiko е платформа за създаване на онлайн магазин без нужда от технически умения. Подходяща е за малки и средни бизнеси, които искат бързо да стартират продажби онлайн. С готови шаблони, лесна администрация и интегрирани разплащания, Shopiko дава всичко необходимо за успех.',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				}
			]
		},
		right: {
			gap: 'gap-8-12', // classname from css file (block.scss) for space between items
			content: [
				{
					title: '20+ готови шаблона',
					subtitle: 'за бърз старт на всеки бизнес',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: 'Интеграция с куриерски фирми',
					subtitle: 'готови модули за лесна интеграция с различни куриери',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: 'Българска поддръжка',
					subtitle: 'за разлика от повечето конкуренти',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: 'Онлайн разплащане',
					subtitle: 'различни методи за плащане онлайн',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				}
			]
		},
		noteData: []
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	blockTitle: '',
	blockDesc: '',
	blockContent: {
		left: {
			gap: 'gap24', // classname from css file (block.scss) for space between items
			content: [
				{
					title: 'Online Store. Fast. Easy. Ready',
					text: 'Shopiko is a platform for creating an online store without any technical skills required. It’s perfect for small and medium businesses looking to start selling online quickly. With ready-made templates, easy administration, and integrated payment options, Shopiko provides everything you need for success.',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				}
			]
		},
		right: {
			gap: 'gap-8-12', // classname from css file (block.scss) for space between items
			content: [
				{
					title: '20+ ready-made templates',
					subtitle: 'for quick start of any business',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: 'Courier Integrations',
					subtitle: 'ready-made modules for easy integration with various courier services',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: 'Local Support in Bulgarian',
					subtitle: 'unlike most competitors',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: 'Online Payments',
					subtitle: 'multiple payment methods included',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				}
			]
		},
		noteData: []
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];